import React from 'react';
import { Link} from 'react-router';
import { resourceApi } from '../utils/fetchUtil';
import Spinner from './Spinner';
import {fireInAppBrowserPlugin} from '../actions/environmentActions';
import HeaderSmall from './Header/HeaderSmall';
import ContactCareGuide from 'material-ui/svg-icons/action/supervisor-account';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import Phone from 'material-ui/svg-icons/communication/phone';
import Web from 'material-ui/svg-icons/av/web';

const style = {
  minHeight: 100,
  padding:25
};

class Content extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            template: null
        };
    }
    
    componentDidMount() {
        this.loadContent();
    }

    loadContent = () => {

        var self = this;

        this.setState({isFetching: true});

        let config = {
            method: 'get',
            url: `content/${this.props.contentKey}`
        };
        if(this.props.secure) {
            config.url += "/secure";
        }

        resourceApi(config) 
        .then(function (response) {
            self.setState({ 
                    template: response.data,
                    isFetching: false 
                });
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    fire = (method) =>{

        let config = {
            method: 'get',
            url: `log/content/${this.state.template.ClientApplicationStaticModuleConfigID}/${method}`
        };

        resourceApi(config) ;
    }

    getContent() {
        return {__html: this.state.template.Text};
    }


    render() {

        return (
            <div>
                {(this.state.isFetching) && (
                    <Spinner />
                )}
                
                {(!this.state.isFetching) && this.state.template && (
                    <div>
                        {this.state.template.Name && (
                            <HeaderSmall title={this.state.template.Name}  /> 
                        )}
                        <div className="container treuno" >
                        <Paper>
                        <div className="container treunoLight">
                            {this.state.template.Image && (
                                <div  >
                                    <img src={this.state.template.Image} style={{width:'100%'}} />
                                </div>
                            )}

                            {this.state.template.Text && (
                                <div dangerouslySetInnerHTML={this.getContent()} />
                            )}
                        </div>
                    {this.state.template.Phone && (
                            <div style={{textAlign:'center', paddingTop: 25, paddingBottom:45}}>
                                <a style={{ textDecoration:"none"}} onClick={() => {this.fire("phone"); fireInAppBrowserPlugin(`tel:${this.state.template.Phone}`)}} >
                                    <RaisedButton icon={<Phone />} primary={true} label={this.state.template.Phone} label="Tap to Call Now" />
                                </a>
                                <br />
                                <br />
                            </div>
                        )}
                     
                    {this.state.template.Url && (
                        <div style={{textAlign:'center', padding: '0 25px 0 25px'}}>
                            <RaisedButton icon={<Web />} onClick={() => {this.fire(); fireInAppBrowserPlugin(this.state.template.Url) }} primary={true} fullWidth={true} label="Access This Benefit" />
                            <br />
                            <br />
                        </div>
                    )}
                   
                    {this.state.template.ContactCareGuide && (
                        <div style={{textAlign:'center', padding: '0 25px 25px 25px'}}>
                            <RaisedButton icon={<ContactCareGuide />}  fullWidth={true} primary={true} label="Contact a Care Guide" containerElement={<Link to={`/message/0/view`} />}  />
                        
                        </div>
                    )}

                </Paper>
                </div>
                </div>

                )}
            </div>
        );
    }

};

export default Content;	


// WEBPACK FOOTER //
// ./src/Components/Content.js